import { createSlice } from '@reduxjs/toolkit'

const searchColumnsSlice = createSlice({
  name: 'searchColumns',
  initialState: {
    activeTab: 'my_columns',
    headerCheckbox: false,
    selectedGridItems: [],
  },
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
    setHeaderCheckboxState: (state, action) => {
      state.headerCheckbox = action.payload
    },
    setSelectedGridItems: (state, action) => {
      state.selectedGridItems = action.payload
    },
  },
})

export const { setActiveTab, setHeaderCheckboxState, setSelectedGridItems } =
  searchColumnsSlice.actions
export default searchColumnsSlice.reducer
